<template>
  <div>
    <div class="row mb-4">
      <div v-if="widgetData.alldata" class="col-5">
        <div class="row mb-4">
          <div class="col-12">
            <div class="card">
              <div class="card-header bg-primary text-white"><i class="fas fa-map-marked-alt mr-2"></i><span>Hamma maydonlar bo'yicha</span>
              </div>
              <div class="card-body">
                <h5>Jami maydonlar : {{widgetData.alldata.totalArea ? widgetData.alldata.totalArea :0}} (ga) </h5>
                <h5>Eng kichik hudud :
                  {{widgetData.alldata.minAreaName ? widgetData.alldata.minAreaName :''}} (
                  {{widgetData.alldata.minArea ? widgetData.alldata.minArea :0}} (ga))</h5>
                <h5>Eng katta hudud :
                  {{widgetData.alldata.maxAreaName ? widgetData.alldata.maxAreaName :''}} (
                  {{widgetData.alldata.maxArea ? widgetData.alldata.maxArea :0}} (ga))</h5>
                <h5>Paxta-g'alla maydonlari : {{widgetData.alldata.paxtaArea ? widgetData.alldata.paxtaArea :0}} (ga)</h5>
                <h5>Fermerlik maydonlari : {{widgetData.alldata.farmersArea ? widgetData.alldata.farmersArea :0}} (ga)</h5>
                <h5>Fermerlar soni : {{widgetData.alldata.farmersCount ? widgetData.alldata.farmersCount :0}} </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12">
            <div class="card">
              <dynamic-chart ref="lineChart" :chartOptions="widgetData.alldata.pieChartData" :needTitle="needTitle"/>
              <dynamic-chart ref="lineChart" :chartOptions="widgetData.alldata.barChartData" :needTitle="needTitle"/>
            </div>
          </div>
        </div>
      </div>
      <div v-if="widgetData.regionData" class="col-5">
        <div class="row mb-4">
          <div class="col-12">
            <div class="card">
              <div class="card-header bg-primary text-white"><i class="fas fa-map-marked-alt mr-2"></i><span>{{widgetData.regionData.title}}</span>
              </div>
              <div class="card-body">
                <h5>Jami maydonlar : {{widgetData.regionData.totalArea ? widgetData.regionData.totalArea :0}} (ga) </h5>
                <h5>Eng kichik hudud :
                  {{widgetData.regionData.minAreaName ? widgetData.regionData.minAreaName :''}} (
                  {{widgetData.regionData.minArea ? widgetData.regionData.minArea :0}} (ga))</h5>
                <h5>Eng katta hudud :
                  {{widgetData.regionData.maxAreaName ? widgetData.regionData.maxAreaName :''}} (
                  {{widgetData.regionData.maxArea ? widgetData.regionData.maxArea :0}} (ga))</h5>
                <h5>Paxta-g'alla maydonlari : {{widgetData.regionData.paxtaArea ? widgetData.regionData.paxtaArea :0}} (ga)</h5>
                <h5>Fermerlik maydonlari : {{widgetData.regionData.farmersArea ? widgetData.regionData.farmersArea :0}} (ga)</h5>
                <h5>Fermerlar soni : {{widgetData.regionData.farmersCount ? widgetData.regionData.farmersCount :0}} </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12">
            <div class="card">
              <dynamic-chart ref="lineChart" :chartOptions="widgetData.regionData.pieChartData" :needTitle="needTitle"/>
              <dynamic-chart ref="lineChart" :chartOptions="widgetData.regionData.barChartData" :needTitle="needTitle"/>
            </div>
          </div>
        </div>
      </div>
      <div v-if="widgetData.districtData" class="col-5">
        <div class="row mb-4">
          <div class="col-12">
            <div class="card">
              <div class="card-header bg-primary text-white"><i class="fas fa-map-marked-alt mr-2"></i><span>{{widgetData.districtData.title}}</span>
              </div>
              <div class="card-body">
                <h5>Jami maydonlar : {{widgetData.districtData.totalArea ? widgetData.districtData.totalArea :0}} (ga) </h5>
                <h5>Eng kichik hudud :
                  {{widgetData.districtData.minAreaName ? widgetData.districtData.minAreaName :''}} (
                  {{widgetData.districtData.minArea ? widgetData.districtData.minArea :0}} (ga))</h5>
                <h5>Eng katta hudud :
                  {{widgetData.districtData.maxAreaName ? widgetData.districtData.maxAreaName :''}} (
                  {{widgetData.districtData.maxArea ? widgetData.districtData.maxArea :0}} (ga))</h5>
                <h5>Paxta-g'alla maydonlari : {{widgetData.districtData.paxtaArea ? widgetData.districtData.paxtaArea :0}} (ga)</h5>
                <h5>Fermerlik maydonlari : {{widgetData.districtData.farmersArea ? widgetData.districtData.farmersArea :0}} (ga)</h5>
                <h5>Fermerlar soni : {{widgetData.districtData.farmersCount ? widgetData.districtData.farmersCount :0}} </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12">
            <div class="card">
              <dynamic-chart ref="lineChart" :chartOptions="widgetData.districtData.pieChartData" :needTitle="needTitle"/>
              <dynamic-chart ref="lineChart" :chartOptions="widgetData.districtData.barChartData" :needTitle="needTitle"/>
            </div>
          </div>
        </div>
      </div>
      <div v-if="widgetData.sectiondata" class="col-5">
        <div class="row mb-4">
          <div class="col-12">
            <div class="card">
              <div class="card-header bg-primary text-white"><i class="fas fa-map-marked-alt mr-2"></i><span>{{widgetData.sectiondata.title}}</span>
              </div>
              <div class="card-body">
                <h5>Jami maydonlar : {{widgetData.sectiondata.totalArea ? widgetData.sectiondata.totalArea :0}} (ga) </h5>
                <h5>Eng kichik hudud :
                  {{widgetData.sectiondata.minAreaName ? widgetData.sectiondata.minAreaName :''}} (
                  {{widgetData.sectiondata.minArea ? widgetData.sectiondata.minArea :0}} (ga))</h5>
                <h5>Eng katta hudud :
                  {{widgetData.sectiondata.maxAreaName ? widgetData.sectiondata.maxAreaName :''}} (
                  {{widgetData.sectiondata.maxArea ? widgetData.sectiondata.maxArea :0}} (ga))</h5>
                <h5>Paxta-g'alla maydonlari : {{widgetData.sectiondata.paxtaArea ? widgetData.sectiondata.paxtaArea :0}} (ga)</h5>
                <h5>Fermerlik maydonlari : {{widgetData.sectiondata.farmersArea ? widgetData.sectiondata.farmersArea :0}} (ga)</h5>
                <h5>Fermerlar soni : {{widgetData.sectiondata.farmersCount ? widgetData.sectiondata.farmersCount :0}} </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12">
            <div class="card">
              <dynamic-chart ref="lineChart" :chartOptions="widgetData.sectiondata.pieChartData" :needTitle="needTitle"/>
              <dynamic-chart ref="lineChart" :chartOptions="widgetData.sectiondata.barChartData" :needTitle="needTitle"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DynamicChart from './DynamicChart';

  export default {
    name: 'DataWidget',
    data() {
      return {
       needTitle: true,
      };
    },
    props: {
      widgetData: {
        type: Object,
        required: false
      },
      title: {
        type: String,
        required: false
      }
    },
    methods: {},
    components: {
      DynamicChart
    }
  };
</script>

<style scoped>

</style>